import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionService {
  private document: Document;
  private readonly window: Window;

  private $isIE11: boolean = undefined;
  get isIE11(): boolean {
    if (this.$isIE11 === undefined) {
      this.$isIE11 =
        (!(this.window as any).ActiveXObject && 'ActiveXObject' in this.window) ||
        (!!(this.window as any).MSInputMethodContext && !!(this.document as any).documentMode);
    }

    return this.$isIE11;
  }

  constructor(@Inject(DOCUMENT) document: any) {
    this.document = document as Document;
    this.window = this.document.defaultView;
  }
}
